import React from 'react'

import { useFeaturedBrandNavigationBanners } from 'modules/brands'

import { buttonMessages } from 'components/inputs'

import BannerBase from '../BannerBase/BannerBase'

import s from './FeaturedBrandBanner.scss'


type FeaturedBrandBannerProps = {
  onClick?: () => void
  placement: BrandsModule.FeaturedBrandNavigationBannerPlacement
  'data-testid'?: string
}

const FeaturedBrandBanner: React.FunctionComponent<FeaturedBrandBannerProps> = (props) => {
  const { placement, onClick, 'data-testid': dataTestId = 'banner' } = props

  const featuredBrandNavigationBanners = useFeaturedBrandNavigationBanners()
  const featuredBrandNavigationBannerData = featuredBrandNavigationBanners?.[placement]

  if (!featuredBrandNavigationBannerData) {
    return null
  }

  const { background, buttonStyle, logo, name, text, textColor, to } = featuredBrandNavigationBannerData

  return (
    <BannerBase
      bgImage={background}
      buttonStyle={buttonStyle}
      buttonTitle={buttonMessages.learnMore}
      content="Featured brand"
      logo={logo}
      logoClassName={s.logo}
      text={text}
      textColor={textColor}
      to={to}
      trackParams={{ productBrand: name }}
      onClick={onClick}
      data-testid={dataTestId}
    />
  )
}

export default FeaturedBrandBanner
